<template>
  <div
    class="wrapper relative mb-4 cursor-pointer"
    :class="active == archetype ? 'active' : ''"
    @click="selectArchetype(archetype)"
  >
    <weise v-if="archetype.slug == 'weise'"></weise>
    <wissenschaftler
      v-if="archetype.slug == 'wissenschaftler'"
    ></wissenschaftler>
    <schoepfer v-if="archetype.slug == 'schoepfer'"></schoepfer>
    <kaempfer v-if="archetype.slug == 'kaempfer'"></kaempfer>
    <trainer v-if="archetype.slug == 'trainer'"></trainer>
    <medicus v-if="archetype.slug == 'medicus'"></medicus>
    <herrscher v-if="archetype.slug == 'herrscher'"></herrscher>
    <rebell v-if="archetype.slug == 'rebell'"></rebell>
    <fuersorgende v-if="archetype.slug == 'fuersorgende'"></fuersorgende>
    <koenig v-if="archetype.slug == 'koenig'"></koenig>
    <magier v-if="archetype.slug == 'magier'"></magier>
    <abenteurer v-if="archetype.slug == 'abenteurer'"></abenteurer>
    <gefaehrte v-if="archetype.slug == 'gefaehrte'"></gefaehrte>
    <liebende v-if="archetype.slug == 'liebende'"></liebende>
    <unschuldige v-if="archetype.slug == 'unschuldige'"></unschuldige>
    <entertainer v-if="archetype.slug == 'entertainer'"></entertainer>

    <p
      class="absolute w-[95%] mx-auto mt-1 h-0.5"
      v-if="archetype.attributeSuffixColor"
      :class="`bg-${archetype.attributeSuffixColor}`"
    ></p>
  </div>
</template>

<script>
import Weise from '@/Pages/Markencode/Shared/Archetypes/Weise.vue';
import Wissenschaftler from '@/Pages/Markencode/Shared/Archetypes/Wissenschaftler.vue';
import Schoepfer from '@/Pages/Markencode/Shared/Archetypes/Schoepfer.vue';
import Kaempfer from '@/Pages/Markencode/Shared/Archetypes/Kaempfer.vue';
import Trainer from '@/Pages/Markencode/Shared/Archetypes/Trainer.vue';
import Medicus from '@/Pages/Markencode/Shared/Archetypes/Medicus.vue';
import Herrscher from '@/Pages/Markencode/Shared/Archetypes/Herrscher.vue';
import Rebell from '@/Pages/Markencode/Shared/Archetypes/Rebell.vue';
import Fuersorgende from '@/Pages/Markencode/Shared/Archetypes/Fuersorgende.vue';
import Koenig from '@/Pages/Markencode/Shared/Archetypes/Koenig.vue';
import Magier from '@/Pages/Markencode/Shared/Archetypes/Magier.vue';
import Abenteurer from '@/Pages/Markencode/Shared/Archetypes/Abenteurer.vue';
import Gefaehrte from '@/Pages/Markencode/Shared/Archetypes/Gefaehrte.vue';
import Liebende from '@/Pages/Markencode/Shared/Archetypes/Liebende.vue';
import Unschuldige from '@/Pages/Markencode/Shared/Archetypes/Unschuldige.vue';
import Entertainer from '@/Pages/Markencode/Shared/Archetypes/Entertainer.vue';

export default {
  components: {
    Weise,
    Wissenschaftler,
    Schoepfer,
    Kaempfer,
    Trainer,
    Medicus,
    Herrscher,
    Rebell,
    Fuersorgende,
    Koenig,
    Magier,
    Abenteurer,
    Gefaehrte,
    Liebende,
    Unschuldige,
    Entertainer,
  },

  props: {
    archetype: {
      required: true,
      default: Object,
    },
    selected: {
      required: false,
      default: Object,
    },
  },

  watch: {
    selected: function (newVal, oldVal) {
      this.active = newVal;
    },
  },

  data() {
    return {
      active: null,
    };
  },

  methods: {
    selectArchetype(archetype) {
      this.$emit('selected', archetype);
    },
  },
};
</script>

<style>
.st0 {
  fill: #000 !important;
}
.st1 {
  stroke: #000 !important;
  fill: none;
  stroke-width: 2.8346;
  stroke-miterlimit: 10;
}
.wrapper:hover svg .st0,
.wrapper.active svg .st0 {
  @apply fill-[#4b5563] !important;
}
.wrapper:hover svg .st1,
.wrapper.active svg .st1 {
  @apply stroke-[#4b5563] !important;
}
</style>